module.exports = __webpack_public_path__ + "img/67.7f8fa1c5.png";